import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommerceProductEntityState} from "../reducers/ecommerce-product.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommerceProductState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerceProduct.entities[websiteId]);

export const getProduct = (websiteId: number) => createSelector(getEcommerceProductState(websiteId),
  (state: IEcommerceProductEntityState) => state.product
);

export const getProductLoading = (websiteId: number) => createSelector(getEcommerceProductState(websiteId),
  (state: IEcommerceProductEntityState) => state && state.loading
);

export const getVariations = (websiteId: number) => createSelector(getEcommerceProductState(websiteId),
  (state: IEcommerceProductEntityState) => state.variations
);

export const getDropdowns = (websiteId: number) => createSelector(getEcommerceProductState(websiteId),
  (state: IEcommerceProductEntityState) => {
    if (state.dropdowns?.currency_symbol) {
      state.dropdowns.currency_symbol = transformCurrency(state.dropdowns?.currency_symbol);
    }

    return state.dropdowns;
  }
);

function transformCurrency(value: string): string {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = value;
  return textarea.value;
}

